import { ENDPOINTS_SOCIAL_SECURITY } from 'common/endpoints/social-security.endpoints';

const TERM_TYPE = {
  CONTRIBUTION : 'contribution',
  SETTLEMENT : 'settlement'
};

export default class SocialSecurityDataService {

  constructor($http) {
    'ngInject';
    this.http = $http;
  }

  getQuoteBasisInitial(employeeId, data) {
    data = data || {};
    return this.http.get(ENDPOINTS_SOCIAL_SECURITY.get.quoteBasisInitial(employeeId), data);
  }

  getContributions(employeeId, year, month) {
    let data = {
      params: {
        'term_type' : TERM_TYPE.CONTRIBUTION,
        'year' : year,
        'month' : month
      }
    };

    return this.getQuoteBasisInitial(employeeId, data);
  }

  getSettlements(employeeId, year, month) {
    let data = {
      params: {
        'term_type' : TERM_TYPE.SETTLEMENT,
        'year' : year,
        'month' : month
      }
    };

    return this.getQuoteBasisInitial(employeeId, data);
  }

}



// WEBPACK FOOTER //
// ./client/app/social-security.module/common/services/social-security.data.service.js